export default function NotFound() {
  return (
    <div className="page">
      <h2>404 - Not Found</h2>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
}